import { render, staticRenderFns } from "./Combo.vue?vue&type=template&id=8dab4170&"
import script from "./Combo.vue?vue&type=script&lang=ts&"
export * from "./Combo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports